// frontend/src/components/FetchIndicatorsButton.jsx
import React, { useState } from "react";
import { useAuth } from "../AuthProvider";

export default function FetchIndicatorsButton() {
  const { token } = useAuth();
  const [tradeDate, setTradeDate] = useState(() => {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  });

  const [isLoading, setIsLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const run = async () => {
    setIsLoading(true);
    setMsg("");
    try {
      const res = await fetch(`/api/indicators/fetch-daily?trade_date=${tradeDate}&max_pages=100&sleep_ms=30`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.detail || data?.message || "Fetch failed");
      setMsg(`✅ Indicators fetched: inserted=${data?.rows?.inserted ?? 0}, updated=${data?.rows?.updated ?? 0}, pages=${data?.pages_fetched ?? "-"}`);
    } catch (e) {
      setMsg(`❌ ${e.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="rounded-xl border border-white/10 bg-white/5 p-3">
      <div className="text-xs text-gray-300 font-semibold">Indicators (GoAPI)</div>

      <label className="mt-2 block text-[11px] text-gray-400">Trade Date</label>
      <input
        type="date"
        value={tradeDate}
        onChange={(e) => setTradeDate(e.target.value)}
        className="mt-1 w-full rounded-lg bg-black/30 border border-white/10 px-2 py-1.5 text-sm text-gray-100"
      />

      <button
        onClick={run}
        disabled={isLoading}
        className="mt-3 w-full rounded-lg bg-indigo-600 hover:bg-indigo-500 disabled:opacity-60 px-3 py-2 text-sm font-semibold text-white"
      >
        {isLoading ? "Fetching..." : "Fetch Indicators (Daily)"}
      </button>

      {msg ? <div className="mt-2 text-xs text-gray-300">{msg}</div> : null}
    </div>
  );
}
